/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Event_Templates_Delete_Failed_ToastInputs */

const en_event_templates_delete_failed_toast = /** @type {(inputs: Event_Templates_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to delete template: ${i?.error}`)
};

const fr_event_templates_delete_failed_toast = /** @type {(inputs: Event_Templates_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de la suppression du modele: ${i?.error}`)
};

const de_event_templates_delete_failed_toast = /** @type {(inputs: Event_Templates_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vorlage konnte nicht gelöscht werden: ${i?.error}`)
};

const it_event_templates_delete_failed_toast = /** @type {(inputs: Event_Templates_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile eliminare il modello: ${i?.error}`)
};

const ru_event_templates_delete_failed_toast = /** @type {(inputs: Event_Templates_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось удалить шаблон: ${i?.error}`)
};

const es_event_templates_delete_failed_toast = /** @type {(inputs: Event_Templates_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo eliminar la plantilla: ${i?.error}`)
};

const zh_cn2_event_templates_delete_failed_toast = /** @type {(inputs: Event_Templates_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`删除模板失败：${i?.error}`)
};

const ja_event_templates_delete_failed_toast = /** @type {(inputs: Event_Templates_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`テンプレートの削除に失敗しました: ${i?.error}`)
};

const hi_event_templates_delete_failed_toast = /** @type {(inputs: Event_Templates_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`टेम्प्लेट को हटाने में विफल: ${i?.error}`)
};

const pt_pt2_event_templates_delete_failed_toast = /** @type {(inputs: Event_Templates_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao excluir o modelo: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to delete template: {error}" |
*
* @param {Event_Templates_Delete_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_templates_delete_failed_toast = /** @type {((inputs: Event_Templates_Delete_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Templates_Delete_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_templates_delete_failed_toast(inputs)
	if (locale === "de") return de_event_templates_delete_failed_toast(inputs)
	if (locale === "it") return it_event_templates_delete_failed_toast(inputs)
	if (locale === "ru") return ru_event_templates_delete_failed_toast(inputs)
	if (locale === "es") return es_event_templates_delete_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_event_templates_delete_failed_toast(inputs)
	if (locale === "ja") return ja_event_templates_delete_failed_toast(inputs)
	if (locale === "hi") return hi_event_templates_delete_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_event_templates_delete_failed_toast(inputs)
	return en_event_templates_delete_failed_toast(inputs)
});